import { RadioGroup, RadioItem } from '@platform/components';
import { UseFormRegisterReturn } from 'react-hook-form';

type SelectionContentProps = {
  description: string;
  items: RadioItem[];
  onChange: (value: string) => void;
  defaultValue?: string;
  register: () => UseFormRegisterReturn<string>;
};

export const SelectionContent = (props: SelectionContentProps) => {
  return (
    <div className='flex flex-col gap-8 items-center md:mt-8 md:w-[500px]'>
      <div className='text-center text-xl'>{props.description}</div>
      <div className='mt-4 w-full'>
        <RadioGroup
          register={props.register}
          name='update-selection'
          aria-label='update-selection'
          isRequired={true}
          items={props.items}
          defaultValue={props.defaultValue}
          onChange={(value) => {
            props.onChange(value as string);
          }}
        />
      </div>
    </div>
  );
};
